<template>
    <div class="RemoveSupporter">
        <div class="row justify-space">
            <div v-if="job.tipo == 'alocacao'" class="grid-3 column">
                <label>Cancela agendamento</label>
                <select v-model="form.cancela_agendamento">
                    <option value="">Selecione</option>
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                </select>
            </div>
            <div v-if="job.tipo == 'alocacao'" class="grid-3 column">
                <label>Reagenda</label>
                <select v-model="form.reagenda">
                    <option value="">Selecione</option>
                    <option :value="true">Sim</option>
                    <option :value="false">Não</option>
                </select>
            </div>
            <div class="grid-4 column">
                <label>Categoria Desassociação</label>
                <select v-model="form.id_flag_desassociacao">
                    <option value="">Selecione</option>
                    <option v-for="f of list" :value="f.id" :key="f.id">{{ f.flag }}</option>
                </select>
            </div>
        </div><br><br>
        <div class="column grid-11">
            Motivo da Remoção
            <input v-model="form.motivo_desassociacao" placeholder="Motivo da Remoção" />
        </div>
        <br><br><br><br>
        <Button @click="remover" :loader="loader" layout="red-go">REMOVER</Button>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";

export default {
    name: "RemoveSupporter",
    components: { Button },
    props: { job: Object, cb: Function },
    data() {
        return {
            loader: false,
            form: {
                cancela_agendamento: false,
                reagenda: false,
                id_flag_desassociacao: null,
                motivo_desassociacao: "",
            },
            list: [],
        };
    },
    methods: {
        ...mapActions("admin", ["FLAGS_LIST"]),
        ...mapActions("job", ["REMOVE_SUPPORTER"]),
        async load() {
            this.loader = true;
            await this.FLAGS_LIST({ filtro: 'desassociacao_doutor', status: 'ativo' }).then(({ data }) => this.list = data || []);
            this.loader = false
        },
        async remover() {
            if (confirm("Deseja remover este supporter do job?")) {
                this.loader = true;
                await this.REMOVE_SUPPORTER({ id: this.job.id, ...this.form });
                this.loader = false;
                this.cb()
            }
        },
    },
    beforeMount() { this.load() }
};
</script>

<style lang="sass" scoped>
  @use "@/assets/scss/vars.scss" as *
  .RemoveSupporter
    padding: 10px 30px
    overflow: auto
    min-width: 600px
    @include label
    label
        margin-bottom: 6px
  </style>